import Axios from "axios";
import { Formik } from "formik";
import * as React from "react";
import { useState } from "react";
import { RouteComponentProps, useLocation } from "react-router-dom";
import { CustomError } from "../Models/CustomError";
import { ResetPwdRequest } from "../Models/ResetPwdRequest";
import { ResetPwdValidationErrors } from "../Models/ResetPwdValidationErrors";
import { isCustomError } from "../Utils";
interface IProps extends RouteComponentProps {}

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const ResetPwd: React.FunctionComponent<IProps> = (
    props: IProps
): JSX.Element => {
    const [reqErrors, setReqErrors] = useState<CustomError>();

    const onCancel = () => {
        props.history.push("/login");
    };
    const query = useQuery();

    return (
        <div className="row justify-content-center">
            <div className="col-4">
                <Formik
                    initialValues={{ pwd: "", resetPwd: "" }}
                    onSubmit={async (values, { setSubmitting }) => {
                        console.log(values);

                        //parse query string
                        const email = query.get("Email");
                        const token = query.get("Token");
                        if (!email || !token) {
                            return;
                        }
                        let data: ResetPwdRequest = {
                            email: email,
                            token: token,
                            password: values.pwd,
                        };

                        try {
                            await Axios.post(process.env.REACT_APP_API_URL + "/api/v1/identity/resetPwd", data);
                        } catch (errors) {
                            if(isCustomError(errors)){
                                //error will be thrown if there were tokens in localstorage and we tried to do isuserauth call
                                setReqErrors(errors);
                            }
                        }
                        setSubmitting(false);
                    }}
                    validate={(values) => {
                        const errors: ResetPwdValidationErrors = {
                            pwd: "",
                            resetPwd: "",
                        };

                        if (!values.pwd) {
                            errors.pwd = "Required";
                        }

                        if (!values.resetPwd) {
                            errors.resetPwd = "Required";
                        }

                        if (values.pwd !== values.resetPwd) {
                            errors.resetPwd = "Passwords do not match";
                        }

                        if (errors.pwd !== "" || errors.resetPwd !== "") {
                            return errors;
                        }

                        return {};
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Password:</label>
                                <input
                                    className="form-control"
                                    required
                                    type="password"
                                    placeholder="password"
                                    id="password"
                                    name="password"
                                    onChange={handleChange("pwd")}
                                    onBlur={handleBlur}
                                    value={values.pwd}
                                />
                                {touched.pwd && (
                                    <small className="form-text text-muted">
                                        {errors.pwd}
                                    </small>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Re-enter Password:</label>
                                <input
                                    className="form-control"
                                    required
                                    type="password"
                                    placeholder="password"
                                    id="resetPassword"
                                    name="resetPassword"
                                    onChange={handleChange("resetPwd")}
                                    onBlur={handleBlur}
                                    value={values.resetPwd}
                                />
                                {touched.resetPwd && (
                                    <small className="form-text text-muted">
                                        {errors.resetPwd}
                                    </small>
                                )}
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                Reset Password
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={onCancel}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </button>
                            {reqErrors?.errors.map(
                                (error: string) => (
                                    <small className="form-text text-muted">
                                        {error}
                                    </small>
                                )
                            )}
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
